import { useEffect, useState } from 'react';

interface FooterItem {
  id: string;
  title: string;
  url: string;
  children?: FooterItem[];
}

export function useFooterMenuData(language: string) {
  const [data, setData] = useState<FooterItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<null | Error>(null);

  useEffect(() => {
    const controller = new AbortController();

    const lang = ['en', 'sv', 'fi'].includes(language) ? language : 'fi';

    const isLocalhost =
      typeof window !== 'undefined' && window.location.hostname === 'localhost';
    const baseUrl = isLocalhost
      ? 'http://localhost:8010/proxy/fi/api'
      : 'https://www.fortum.com/fi/api';

    const url = `${baseUrl}/${lang}/menu/footer`;

    fetch(url, { signal: controller.signal })
      .then(res => {
        if (!res.ok) throw new Error(`Failed to fetch footer: ${res.status}`);
        return res.json();
      })
      .then(jsonData => {
        if (Array.isArray(jsonData)) {
          setData(jsonData);
        } else {
          setData([]);
        }
      })
      .catch(err => {
        if (err.name !== 'AbortError') {
          setError(err);
          setData([]);
        }
      })
      .finally(() => setLoading(false));

    return () => controller.abort();
  }, [language]);

  return { data, loading, error };
}
